/* esm.sh - unhead@3.4.1/dist/shared/unhead.Bm4Y6XQI */
import{HookableCore as r}from"hookable";function c(o){let n=new r;for(let t in o||{})n.hook(t,o[t]);return n}function k(o,n,t){if(o.hooks?._hooks?.[n]?.length)return o.hooks?.callHook(n,t)}export{k as a,c};
//# sourceMappingURL=unhead.Bm4Y6XQI.mjs.map